import { hydrate } from 'davaux/client'
import __island_0 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/ColorPicker.js"
import __island_1 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/ColorSchemePicker.js"
import __island_2 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/Combobox.js"
import __island_3 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/CopyButton.js"
import __island_4 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/DataViewReactive.js"
import __island_5 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/DataTable.js"
import __island_6 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/DateInput.js"
import __island_7 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/DatePicker.js"
import __island_8 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/Drawer.js"
import __island_9 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/Menu.js"
import __island_10 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/Modal.js"
import __island_11 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/MultiSelect.js"
import __island_12 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/Notification.js"
import __island_13 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/PasswordInput.js"
import __island_14 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/PinInput.js"
import __island_15 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/RangeSlider.js"
import __island_16 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/Select.js"
import __island_17 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/Slider.js"
import __island_18 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/Spoiler.js"
import __island_19 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/Spotlight.js"
import __island_20 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/TagsInput.js"
import __island_21 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/ThemeToggle.js"
import __island_22 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/islands/ColorSchemePicker.tsx"
import __island_23 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/islands/CopyButton.tsx"
import __island_24 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/islands/Drawer.tsx"
import __island_25 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/islands/Menu.tsx"
import __island_26 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/islands/Modal.tsx"
import __island_27 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/islands/Notification.tsx"
import __island_28 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/islands/PasswordInput.tsx"
import __island_29 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/islands/PinInput.tsx"
import __island_30 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/islands/Select.tsx"
import __island_31 from "/cabinet/Dev/Davaux/davaux/packages/ui/dist/islands/ThemeToggle.tsx"

hydrate({
  "ColorPicker": async () => ({ default: __island_0 }),
  "ColorSchemePicker": async () => ({ default: __island_1 }),
  "Combobox": async () => ({ default: __island_2 }),
  "CopyButton": async () => ({ default: __island_3 }),
  "DataViewReactive": async () => ({ default: __island_4 }),
  "DataTable": async () => ({ default: __island_5 }),
  "DateInput": async () => ({ default: __island_6 }),
  "DatePicker": async () => ({ default: __island_7 }),
  "Drawer": async () => ({ default: __island_8 }),
  "Menu": async () => ({ default: __island_9 }),
  "Modal": async () => ({ default: __island_10 }),
  "MultiSelect": async () => ({ default: __island_11 }),
  "Notification": async () => ({ default: __island_12 }),
  "PasswordInput": async () => ({ default: __island_13 }),
  "PinInput": async () => ({ default: __island_14 }),
  "RangeSlider": async () => ({ default: __island_15 }),
  "Select": async () => ({ default: __island_16 }),
  "Slider": async () => ({ default: __island_17 }),
  "Spoiler": async () => ({ default: __island_18 }),
  "Spotlight": async () => ({ default: __island_19 }),
  "TagsInput": async () => ({ default: __island_20 }),
  "ThemeToggle": async () => ({ default: __island_21 }),
  "islands/ColorSchemePicker": async () => ({ default: __island_22 }),
  "islands/CopyButton": async () => ({ default: __island_23 }),
  "islands/Drawer": async () => ({ default: __island_24 }),
  "islands/Menu": async () => ({ default: __island_25 }),
  "islands/Modal": async () => ({ default: __island_26 }),
  "islands/Notification": async () => ({ default: __island_27 }),
  "islands/PasswordInput": async () => ({ default: __island_28 }),
  "islands/PinInput": async () => ({ default: __island_29 }),
  "islands/Select": async () => ({ default: __island_30 }),
  "islands/ThemeToggle": async () => ({ default: __island_31 }),
})